module.exports = __webpack_public_path__ + "img/encourage.c217781b.png";